
        var result = require("!!./../../../../node_modules/css-loader/index.js!./stil.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/05-01/stil.css
// module id = 51
// module chunks = 0